<template>
  <transition name="drawer-slide">
    <div
        v-if="show && (mobileFullscreen || width >= 768)"
        class="modal"
        :style="{'z-index': customIndex}"
    >
      <div @click.stop :class="`modal-content ${extraClasses}`">
        <slot></slot>
      </div>
    </div>
  </transition>
  <el-drawer
      v-if="show && !mobileFullscreen && width < 768"
      class="modal drawer-overlay rounded-t-12xl"
      :model-value="show"
      :show-close="false"
      :with-header="true"
      :style="{'z-index': customIndex}"
      :append-to-body="true"
      :direction="direction"
      :size="drawerHeight"
      :modal="true"
      :lock-scroll="true"
      :close-on-click-modal="false"

  >
    <template #header>
      <div class="flex items-center justify-center rounded-t-2xl test">
        <div class="bg-bw-grey w-16 h-2"></div>
      </div>
    </template>
    <div>
      <slot></slot>
    </div>
  </el-drawer>
</template>

<script setup lang="ts">
import {ElDrawer} from "element-plus";
import {onBeforeUnmount, onMounted, ref} from "vue";
import type { DrawerProps } from 'element-plus'
const direction = ref<DrawerProps['direction']>('btt')
// Define props and emits
defineProps({
  show: Boolean,
  classes: String,
  mobileFullscreen: {
    default: true,
    type: Boolean,
    required: false,
  },
  drawerHeight: {
    default: "80%",
    type: String,
    required: false,
  },
  extraClasses: {
    default: "",
    type: String,
    required: false,
  },
  mobileClose: {
    default: false,
    type: Boolean,
    required: false,
  },
  customIndex: {
    default: 20,
    type: Number,
    required: false,
  },
});

const emit = defineEmits(["close"]);

const width = ref(window.innerWidth);

function resize() {
  width.value = window.innerWidth;
}

onMounted(() => {
  window.addEventListener("resize", resize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
});

</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* Ensures modal is always on top */
  pointer-events: auto; /* Ensures modal captures clicks */
}

.modal-content {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-height: 100%;
  overflow-y: hidden;
  pointer-events: auto;
}
.drawer-overlay {
  pointer-events: auto; /* Blocks clicks outside the drawer */
}


.modal-enter-active {
  animation: modal 0.3s ease-out;
}

.modal-leave-active {
  animation: modal 0.3s ease-out;
}

@keyframes modal {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .modal-content {
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    border-radius: unset;
  }
}
.modal,
.modal-content {
  touch-action: manipulation;
}
</style>